import GenericModal from '../modal/GenericModal';
import VariableList from './VariableList';

const VariablePickerModal = ({
    onSelect,
    onHide,
    modalContainer,
}: {
    onSelect: (variableName: string) => void;
    onHide: () => void;
    modalContainer?: HTMLElement | null | undefined;
}) => {
    return (
        <GenericModal
            title="Select an Environment Variable"
            onHide={onHide}
            renderBody={() => <VariableList onSelect={onSelect} />}
            container={modalContainer}
        ></GenericModal>
    );
};

export default VariablePickerModal;
